import { useContext, useMemo } from "react";

import { BrazeOperatorContext } from "@lib/BrazeOperatorContext";
import { AgenticAiContext } from "@lib/agenticAi";
import type { AgenticAiContextType } from "@lib/agenticAi";

const noOpCleanup = () => {};

const suppressedRegistrationActions: Pick<
  AgenticAiContextType,
  | "registerContext"
  | "registerAttachedFiles"
  | "registerTool"
  | "registerSkill"
  | "registerLiquidField"
  | "unregisterLiquidField"
> = {
  registerContext: () => noOpCleanup,
  registerAttachedFiles: () => noOpCleanup,
  registerTool: () => noOpCleanup,
  registerSkill: () => noOpCleanup,
  registerLiquidField: () => {},
  unregisterLiquidField: () => {},
};

export const useAgenticAiContext = () => {
  const context = useContext(AgenticAiContext);
  const { isOperatorSuppressed } = useContext(BrazeOperatorContext);

  return useMemo<AgenticAiContextType>(() => {
    if (!isOperatorSuppressed) {
      return context;
    }

    return {
      ...context,
      ...suppressedRegistrationActions,
    };
  }, [context, isOperatorSuppressed]);
};
